import React, { Component } from "react";
import moment from "moment";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Button, Col, DatePicker, Form, Image, Input, Modal, Row, Space, Upload } from "antd";
import { UploadNoticeStates } from "./types/UploadNoticeTypes";
import { SaveOutlined, UploadOutlined, RightCircleOutlined } from "@ant-design/icons";
import { docUploadApiService } from "../../services/otodis/DocUploadApiService";
import SelectTypeNotice from "../../components/selects/SelectTypeNotice";
import ServicebureauSelect from "../../components/servicebureau/ServicebureauSelect";

export interface UploadNoticeProps {}

class UploadNotice extends Component<UploadNoticeProps & any, UploadNoticeStates> {
  private readonly initState!: UploadNoticeStates;

  constructor(props: (UploadNoticeProps & any) | any) {
    super(props);

    this.initState = {
      submitting: false,
      showUploadList: false,

      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),

      inputVehicleEngine: "",
      typeNotice: "",
      serviceBureauCode: "",
      serviceBureauName: "",

      inputImage: [],
      validImage: false,
      inputImagePreview: "",
      hiddenImage: "",

      modalMismatchVisible: false,
      modalInputDesc: "",

      resultObject: {},
      resultNoNotice: "",
      resultCustomerName: "",
      resultCustomerAddress: "",
      resultEngineNumber: "",
      resultChassisNumber: "",
      resultLicensePlateNumber: "",
      resultBpkbNumber: "",
      resultExpireAt: "",
      resultNikNohp: "",
      resultBbnkb: 0,
      resultPkb: 0,
      resultSwdkllj: 0,
      resultPenerbitanStnk: 0,
      resultPenerbitanTnkb: 0,
      resultJumlah: 0,
      resultOwnershipOrder: 0,
    };
    this.state = { ...this.initState };
    // this.formInput = React.createRef();
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  changeTypeNotice = (v: string) => {
    this.setState({
      typeNotice: v,
    });
  };

  onFieldChange = <
    T extends keyof Pick<
      any,
      | "resultNoNotice"
      | "resultCustomerName"
      | "resultCustomerAddress"
      | "resultEngineNumber"
      | "resultChassisNumber"
      | "resultLicensePlateNumber"
      | "resultBpkbNumber"
      | "resultExpireAt"
      | "resultNikNohp"
      | "resultBbnkb"
      | "resultPkb"
      | "resultSwdkllj"
      | "resultPenerbitanStnk"
      | "resultPenerbitanTnkb"
      | "resultJumlah"
      | "resultOwnershipOrder"
    >
  >(
    target: T,
    value: string
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "resultNoNotice":
        currentState.resultNoNotice = value;
        break;
      case "resultCustomerName":
        currentState.resultCustomerName = value;
        break;
      case "resultCustomerAddress":
        currentState.resultCustomerAddress = value;
        break;
      case "resultEngineNumber":
        currentState.resultEngineNumber = value;
        break;
      case "resultChassisNumber":
        currentState.resultChassisNumber = value;
        break;
      case "resultLicensePlateNumber":
        currentState.resultLicensePlateNumber = value;
        break;
      case "resultBpkbNumber":
        currentState.resultBpkbNumber = value;
        break;
      case "resultExpireAt":
        currentState.resultExpireAt = value;
        break;
      case "resultNikNohp":
        currentState.resultNikNohp = value;
        break;
      case "resultBbnkb":
        currentState.resultBbnkb = value;
        break;
      case "resultPkb":
        currentState.resultPkb = value;
        break;
      case "resultSwdkllj":
        currentState.resultSwdkllj = value;
        break;
      case "resultPenerbitanStnk":
        currentState.resultPenerbitanStnk = value;
        break;
      case "resultPenerbitanTnkb":
        currentState.resultPenerbitanTnkb = value;
        break;
      case "resultJumlah":
        currentState.resultJumlah = value;
        break;
      case "resultOwnershipOrder":
        currentState.resultOwnershipOrder = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  changeInputVehicleEngine = (v: any) => {
    this.setState({
      inputVehicleEngine: v.target.value,
    });
  };

  onServiceBureauChange = (data: any) => {
    this.setState({
      serviceBureauCode: data.value,
      serviceBureauName: data.children,
    });
  };

  beforeUploadFile = (file: any) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      Modal.error({
        title: "Validation Error",
        content: "Format File Bukan JPG/PNG",
      });
    }
    if (isJpgOrPng) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.setState({
          inputImagePreview: event.target.result,
          inputImage: file,
          validImage: true,
        });
      };

      reader.readAsDataURL(file);
    } else {
      this.setState({
        validImage: false,
      });
    }
    return false;
  };

  onExtractDokumen = async () => {
    try {
      const { typeNotice, inputVehicleEngine, inputImage, validImage } = this.state;

      if (!typeNotice) {
        throw new Error("Nomor Dokumen tidak valid");
      }
      if (!inputVehicleEngine) {
        throw new Error("Nomor Mesin tidak valid");
      }
      if (!validImage) {
        throw new Error("File Dokumen tidak valid");
      }
      this.setState({
        submitting: true,
      });

      const formData = new FormData();
      formData.append("notice_type", typeNotice);
      formData.append("vehicle_engine_number", inputVehicleEngine);

      if (validImage) {
        formData.append("document", inputImage);
      }

      let extractedData = await docUploadApiService.extractNotice(formData);
      console.log("expire_at", extractedData?.data?.data?.expire_at);
      console.log("typeof expire_at", typeof extractedData?.data?.data?.expire_at);

      this.setState({
        submitting: false,
        resultObject: extractedData?.data?.data,
        resultNoNotice: extractedData?.data?.data?.no_notice,
        resultCustomerName: extractedData?.data?.data?.customer_name,
        resultCustomerAddress: extractedData?.data?.data?.customer_address,
        resultEngineNumber: extractedData?.data?.data?.engine_number,
        resultChassisNumber: extractedData?.data?.data?.chassis_number,
        resultLicensePlateNumber: extractedData?.data?.data?.license_plate_number,
        resultBpkbNumber: extractedData?.data?.data?.bpkb_number,
        resultExpireAt: extractedData?.data?.data?.expire_at === "Invalid date" ? new Date() : extractedData?.data?.data?.expire_at,
        resultNikNohp: extractedData?.data?.data?.nik_nohp,
        resultBbnkb: extractedData?.data?.data?.bbnkb?.toLocaleString(),
        resultPkb: extractedData?.data?.data?.pkb?.toLocaleString(),
        resultSwdkllj: extractedData?.data?.data?.swdkllj?.toLocaleString(),
        resultPenerbitanStnk: extractedData?.data?.data?.penerbitan_stnk?.toLocaleString(),
        resultPenerbitanTnkb: extractedData?.data?.data?.penerbitan_tnkb?.toLocaleString(),
        resultJumlah: extractedData?.data?.data?.jumlah?.toLocaleString(),
        resultOwnershipOrder: extractedData?.data?.data?.ownership_order,
      });
    } catch (error: any) {
      this.setState({
        submitting: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  changeModalInputDesc = (v: any) => {
    this.setState({
      modalInputDesc: v.target.value,
    });
  };

  handleCancel = () => {
    this.setState({ modalMismatchVisible: false });
  };

  handleReportData = async (is_data_valid: any) => {
    try {
      const { ...currentState } = this.state;
      console.log("X", is_data_valid);
      // return;

      if (Object.keys(currentState.resultObject).length < 1) {
        throw new Error("Belum mengextract data");
      }
      if (!currentState.typeNotice) {
        throw new Error("Tipe Notice  tidak valid");
      }
      if (!currentState.inputVehicleEngine) {
        throw new Error("Nomor Mesin tidak valid");
      }
      if (!currentState.validImage) {
        throw new Error("File Dokumen tidak valid");
      }

      const formData = new FormData();

      formData.append("service_bureau_code", currentState.serviceBureauCode);
      formData.append("vehicle_engine_number", currentState.inputVehicleEngine);
      formData.append("description", currentState.modalInputDesc);
      formData.append("is_data_valid", is_data_valid);
      formData.append("textract_no_notice", currentState?.resultObject?.no_notice);
      formData.append("textract_customer_name", currentState?.resultObject?.customer_name);
      formData.append("textract_customer_address", currentState?.resultObject?.customer_address);
      formData.append("textract_engine_number", currentState?.resultObject?.engine_number);
      formData.append("textract_chassis_number", currentState?.resultObject?.chassis_number);
      formData.append("textract_license_plate_number", currentState?.resultObject?.license_plate_number);
      formData.append("textract_bpkb_number", currentState?.resultObject?.bpkb_number);
      formData.append("textract_expire_at", currentState?.resultObject?.expire_at);
      formData.append("textract_nik_nohp", currentState?.resultObject?.nik_nohp);
      formData.append("textract_bbnkb", currentState?.resultObject?.bbnkb);
      formData.append("textract_pkb", currentState?.resultObject?.pkb);
      formData.append("textract_swdkllj", currentState?.resultObject?.swdkllj);
      formData.append("textract_penerbitan_stnk", currentState?.resultObject?.penerbitan_stnk);
      formData.append("textract_penerbitan_tnkb", currentState?.resultObject?.penerbitan_tnkb);
      formData.append("textract_jumlah", currentState?.resultObject?.jumlah);
      formData.append("ownership_order", currentState?.resultObject?.ownership_order);

      if (currentState.validImage) {
        formData.append("document_image", currentState.inputImage);
      }

      this.setState({
        submitting: true,
      });

      await docUploadApiService.uploadNotice(formData).then(async (data) => {
        Modal.success({
          title: "Process Success",
          content: "SUCCESS",
        });
        this.setState({
          submitting: false,
          modalMismatchVisible: false,
        });
      });
    } catch (error: any) {
      this.setState({
        submitting: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Dokumen`}
          breadcrumbMenu={`Upload Doc Engine`}
          defaultSelectedKeys={["m-upload-doc-engine"]}
          defaultOpenKeys={["sm-document"]}
        >
          <Form layout="vertical">
            <Row>
              <Col xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
                <Row>
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 24 }}>
                    <SelectTypeNotice value={this.state.typeNotice} onChangeValue={this.changeTypeNotice} />
                  </Col>
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 24 }}>
                    <Form.Item label="Biro Jasa">
                      <ServicebureauSelect onSupplierChangeProps={this.onServiceBureauChange} dealerCode={this.state.dealerCode} value={this.state.serviceBureauCode} />
                    </Form.Item>
                  </Col>
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 24 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={this.state.inputVehicleEngine} onChange={this.changeInputVehicleEngine} placeholder="Nomor Mesin" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 24 }}>
                    <br />
                    Upload Notice
                    <hr style={{ border: "1px solid #DDD" }} />
                    <Space.Compact>
                      <Form.Item style={{ display: this.state.hiddenImage }}>
                        <Upload maxCount={1} showUploadList={false} beforeUpload={this.beforeUploadFile}>
                          <Button icon={<UploadOutlined />} loading={this.state.submitting} style={{ width: "100%" }}>
                            Select File
                          </Button>
                        </Upload>
                      </Form.Item>
                      <Form.Item>
                        <Button
                          onClick={this.onExtractDokumen}
                          type="primary"
                          icon={<RightCircleOutlined />}
                          title="Simpan"
                          style={{ background: "#1784b8", borderColor: "#1784b8" }}
                          loading={this.state.submitting}
                        >
                          Extract Dokumen
                        </Button>
                      </Form.Item>
                    </Space.Compact>
                    {this.state.inputImagePreview && (
                      <Form.Item>
                        <Image width={"inherit"} src={this.state.inputImagePreview} />
                      </Form.Item>
                    )}
                  </Col>
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 18 }} lg={{ span: 18 }} md={{ span: 16 }} sm={{ span: 24 }}>
                    <br />
                    Hasil Extract Dokumen
                    <hr style={{ border: "1px solid #DDD" }} />
                    <Row>
                      <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 24 }} sm={{ span: 24 }}>
                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nomor Notice">
                              <Input value={this.state.resultNoNotice} placeholder="Nomor Notice" onChange={(event) => this.onFieldChange("resultNoNotice", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nama Konsumen">
                              <Input value={this.state.resultCustomerName} placeholder="Nama Konsumen" onChange={(event) => this.onFieldChange("resultCustomerName", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Alamat Konsumen">
                              <Input value={this.state.resultCustomerAddress} placeholder="Alamat Konsumen" onChange={(event) => this.onFieldChange("resultCustomerAddress", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="NIK / Nomor Telepon">
                              <Input value={this.state.resultNikNohp} placeholder="NIK / Nomor Telepon" onChange={(event) => this.onFieldChange("resultNikNohp", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Tanggal Kadaluarsa">
                              {/* <Input value={this.state.resultExpireAt} placeholder="Tanggal Kadaluarsa" onChange={(event) => this.onFieldChange("resultExpireAt", event.target.value)} /> */}
                              <DatePicker
                                value={moment(this.state.resultExpireAt, "YYYY-MM-DD")}
                                format={"YYYY-MM-DD"}
                                style={{ width: "100%" }}
                                onChange={(date, dateString) => this.onFieldChange("resultExpireAt", dateString)}
                                disabledDate={(current) => current && current < moment().startOf("day")}
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Kepemilikan Ke">
                              <Input value={this.state.resultOwnershipOrder} placeholder="Kepemilikan Ke" onChange={(event) => this.onFieldChange("resultOwnershipOrder", event.target.value)} />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 24 }} sm={{ span: 24 }}>
                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nomor Mesin">
                              <Input value={this.state.resultEngineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onFieldChange("resultEngineNumber", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nomor Rangka">
                              <Input value={this.state.resultChassisNumber} placeholder="Nomor Rangka" onChange={(event) => this.onFieldChange("resultChassisNumber", event.target.value)} />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nomor Polisi">
                              <Input value={this.state.resultLicensePlateNumber} placeholder="Nomor Polisi" onChange={(event) => this.onFieldChange("resultLicensePlateNumber", event.target.value)} />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Nomor BPKB">
                              <Input value={this.state.resultBpkbNumber} placeholder="Nomor BPKB" onChange={(event) => this.onFieldChange("resultBpkbNumber", event.target.value)} />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Biaya BBNKB">
                              <Input value={this.state.resultBbnkb} placeholder="Biaya BBNKB" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Biaya PKB">
                              <Input value={this.state.resultPkb} placeholder="Biaya PKB" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Biaya SWDKLLJ">
                              <Input value={this.state.resultSwdkllj} placeholder="Biaya SWDKLLJ" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Biaya Penerbitan STNK">
                              <Input value={this.state.resultPenerbitanStnk} placeholder="Biaya Penerbitan STNK" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Biaya Penerbitan TNKB">
                              <Input value={this.state.resultPenerbitanTnkb} placeholder="Biaya Penerbitan TNKB" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                          <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                            <Form.Item label="Total Biaya Samsat">
                              <Input value={this.state.resultJumlah} placeholder="Total Biaya Samsat" className="text-right text-info" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                        <br />
                        <Form.Item>
                          <Space.Compact>
                            <Button
                              onClick={() => this.handleReportData(true)}
                              type="primary"
                              icon={<SaveOutlined />}
                              style={{ background: "#1784b8", borderColor: "#1784b8" }}
                              loading={this.state.submitting}
                            >
                              Upload Notice
                            </Button>
                          </Space.Compact>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UploadNotice), 63);
